import { NgModule } from '@angular/core';
import {Routes,RouterModule} from '@angular/router';
import {InsuranceCarriersSubscribersComponent} from './insurance-carriers-subscribers.component';

const routes: Routes = [
  { path: '', component: InsuranceCarriersSubscribersComponent }
];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ]
  })
export class InsuranceCarriersSubscribersRoutingModule { }
